/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('activities/activity-timer',['require','jquery','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var $ = require('jquery');
  //var _ = require('underscore');
  //var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var ActivityTimer = Marionette.Object.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    delay: null,
    currentCount: 0,
    maxCount: -1,
    timeInt: null,

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function($delay, $maxCount)
    {
      this.maxCount = ($maxCount === undefined) ? -1 : $maxCount;
      this.delay = $delay;
      this.currentCount = 0;
    },

    start: function()
    {
      this.timeInt = setInterval($.proxy(this.tick, this), this.delay);
    },

    stop: function()
    {
      clearInterval(this.timeInt);
      this.timeInt = null;
    },

    reset: function()
    {
      this.stop();
      this.currentCount = 0;
    },

    tick: function()
    {
      this.currentCount++;
      this.trigger(ActivityTimer.TIMER);
      if (this.maxCount !== -1 && this.currentCount >= this.maxCount)
        this.finish();
    },

    finish: function()
    {
      this.trigger(ActivityTimer.TIMER_COMPLETE);
      this.reset();
    }

  /*****************************************************************************************************************///}

  });

  ActivityTimer.TIMER = 'timer.tick';
  ActivityTimer.TIMER_COMPLETE = 'timer.complete';

  return ActivityTimer;

});

